var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMongodb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1749 5.28751C16.1249 4.03751 15.2124 2.78751 15.0374 2.51251H14.9999C14.8249 2.77501 13.9124 4.03751 12.8624 5.28751C3.86244 16.775 14.2874 24.525 14.2874 24.525L14.3749 24.5875C14.4499 25.775 14.6499 27.5 14.6499 27.5H15.4249C15.4249 27.5 15.6124 25.7875 15.6874 24.5875L15.7749 24.5125C15.7749 24.5125 26.1749 16.775 17.1749 5.28751ZM14.9999 24.35C14.7809 24.17 14.5799 23.9691 14.3999 23.75L14.9999 11.25L15.5624 23.75C15.3938 23.9669 15.2055 24.1678 14.9999 24.35Z",
    fill: "#606060"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMongodb);
export default __webpack_public_path__ + "static/media/mongodb.dd101650f79cecbf3ce6823d93533377.svg";
export { ForwardRef as ReactComponent };